import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex gap-2 overflow-hidden p-2 flex-grow" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "rounded-xl p-1 border w-[100px] hover:bg-white" }
const _hoisted_4 = ["innerHTML"]

import TRTable from "@/components/Base/TRTable.vue";
import {onMounted, ref} from "vue";
import {query} from "@/graphql";
import {electron, ScriptLanguage} from "@/electron";


export default /*@__PURE__*/_defineComponent({
  __name: 'Apps',
  setup(__props) {


const selectedRow = ref(-1);


const windows1 = () => {
  electron.openNewWindow("window1", "http://localhost:8101/article/123",{
    modal: true,
  });
}

const windows2 = () => {
  electron.openNewWindow("window2", "http://localhost:8101/article/123",{
    frame: false,
  });
}

const windows3 = () => {
  electron.openNewWindow("window3", "http://localhost:8101/article/123",{
    parent: 'main',
  });
}

const windows4 = () => {
  electron.openNewWindow("window4", "http://localhost:8101/article/123",{
    parent: 'main',
    titleBarStyle: 'default',
  });
}

const windows5 = () => {
  electron.openNewWindow("window5", "http://localhost:8101/article/123",{
    titleBarStyle: 'hidden',
  });
}

const windows6 = () => {
  electron.openNewWindow("window6", "http://localhost:8101/article/123",{
    alwaysOnTop: true,
    height: 400,
    width: 300,
  });
}
const windows7 = () => {
  electron.runScript(ScriptLanguage.JavaScript, `
  windows['window6'].setSize(600,600);
  `);
}



const formatCellValue = (rowData, field) => {
  return rowData[field];
}

const header = ref([
  {
    title: "Name",
    field: "name",
    width: 150,

  }, {
    title: "Beschreibung",
    field: "description",
    width: null,

  }, {
    title: "Version",
    field: "version",
    width: 100,

  }, {
    title: "Aktion",
    field: "action",
    width: 130,

  },
]);


const dataRows = ref([]);

onMounted(async () => {
  const [packages, packagesErr] = await query.getPackages();
  if (packagesErr) {
    console.error("Error loading packages", packagesErr);
  } else {
    dataRows.value = packages;
  }
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TRTable, {
      dataRows: dataRows.value,
      header: header.value
    }, {
      cell: _withCtx(({ row, field }) => [
        (field === 'action')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row['actions'], (action) => {
                return (_openBlock(), _createElementBlock("button", _hoisted_3, _toDisplayString(action.title), 1))
              }), 256))
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "overflow-hidden whitespace-nowrap text-ellipsis",
              innerHTML: formatCellValue(row, field)
            }, null, 8, _hoisted_4))
      ]),
      _: 1
    }, 8, ["dataRows", "header"]),
    _createElementVNode("div", { class: "flex flex-grow w-[300px] bg-trader-dark-gray flex-shrink-0 rounded" }, [
      _createElementVNode("div", { class: "flex flex-col" }, [
        _createElementVNode("button", {
          onClick: windows1,
          class: ""
        }, "Window 1"),
        _createElementVNode("button", {
          onClick: windows2,
          class: ""
        }, "Window 2"),
        _createElementVNode("button", {
          onClick: windows3,
          class: ""
        }, "Window 3"),
        _createElementVNode("button", {
          onClick: windows4,
          class: ""
        }, "Window 4"),
        _createElementVNode("button", {
          onClick: windows5,
          class: ""
        }, "Window 5"),
        _createElementVNode("button", {
          onClick: windows6,
          class: ""
        }, "Window 6"),
        _createElementVNode("button", {
          onClick: windows7,
          class: ""
        }, "Window 7")
      ])
    ])
  ]))
}
}

})